<template>
  <div class="layout-container vbox">
    <HeaderMain :class="{ active: isActive }" @toggle="toggleActive" @close-menu="isActive = false" />
    <section class="main hbox space-between">
      <SidebarNav :path="route.path" :class="{ active: isActive }" @toggle="toggleActive" />
      <div class="view-wrapper">
        <router-view v-slot="{ Component }">
            <transition name="crossfade">
                <component :is="Component" :key="route.fullPath" />
            </transition>
        </router-view>
      </div>
    </section>
    <footer class="footer">
      <div class="copyright">&copy; {{ currentYear }} <a href="https://www.lcp.com/en/investment" target="_blank">Lane Clark &amp; Peacock LLP</a>. All rights reserved.</div>
      <div class="links">
        <a href="/terms-and-conditions" target="_blank">Terms & conditions</a>
        <a href="https://www.lcp.com/privacy-policy/" target="_blank">Privacy policy</a>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
    import HeaderMain from './header.vue';
    import SidebarNav from './nav.vue';
    import { ref, watch, onUnmounted } from 'vue';
    import { useRoute } from 'vue-router';

    const isActive = ref(false);
    const currentYear = new Date().getFullYear();
    const route = useRoute();

    function toggleActive() {
      isActive.value = !isActive.value;
    }

    watch(isActive, (newVal) => {
        if (newVal) {
            document.documentElement.style.setProperty('overflow', 'hidden', 'important');
            document.body.style.setProperty('overflow', 'hidden', 'important');
        } else {
            document.documentElement.style.removeProperty('overflow');
            document.body.style.removeProperty('overflow');
        }
    });

    onUnmounted(() => {
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
    });
</script>

<style lang="scss">


    .view-wrapper {
        flex: 1 1 auto;
        position: relative;
        overflow-y: hidden;
        display: flex;
        min-width: calc(100vw - 317px);
    }

    /* Inner view transition - Content Only */
    .crossfade-enter-active,
    .crossfade-leave-active {
        transition: opacity 0.8s ease;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
    }
    .crossfade-enter-from,
    .crossfade-leave-to {
        opacity: 0;
    }

    /* Tablet Landscape / Small Desktop */
    @media only screen and (min-width: 821px) and (max-width: 1024px) {
        .view-wrapper {
            min-width: calc(100% - 317px);
            width: calc(100% - 317px);
        }
    }

    /* Tablet Portrait */
    @media only screen and (min-width: 768px) and (max-width: 820px) {
        .view-wrapper {
             overflow: visible !important;
             height: auto !important;
             display: block;
        }
    }

    /* Mobile Landscape */
    @media only screen and (min-width: 576px) and (max-width: 767px) {
         .view-wrapper {
             overflow: visible !important;
             height: auto !important;
             display: block;
        }
    }

    /* Mobile Portrait */
    @media only screen and (max-width: 575px) {
         .view-wrapper {
             overflow: visible !important;
             height: auto !important;
             display: block;
        }
    }
    /* Mobile Landscape (Specific Fix for wide phones) */
    @media only screen and (max-width: 950px) and (orientation: landscape) and (max-height: 500px) {
         .view-wrapper {
             overflow: visible !important;
             height: auto !important;
             display: block;
             width: 100% !important;
             min-width: 100% !important;
        }
    }
</style>
